module.exports = __webpack_public_path__ + "media/images/gallery/star_tab_on-6d90b6195c7e483ca6cfa44e2720b4cc.jpg";